"use client";

import Link from "next/link";
import type { Route } from "next";
import { usePathname } from "next/navigation";

const TABS = [
  { slug: "", label: "Slides" },
  { slug: "/livret", label: "Livret" },
  { slug: "/quiz", label: "Quiz" },
] as const;

export function PreviewTabs({ projectId }: { projectId: string }) {
  const pathname = usePathname();
  const base = `/projects/${projectId}/preview`;

  return (
    <nav className="preview-tabs" aria-label="Vues d'aperçu">
      {TABS.map((t) => {
        const href = `${base}${t.slug}` as Route;
        const active = pathname === href || (t.slug === "" && pathname === base);
        return (
          <Link
            key={t.slug || "slides"}
            href={href}
            className={`preview-tab ${active ? "active" : ""}`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
